import { axiosClient } from '@/services/api/axios'
import { tokenStorage } from '@/lib/auth/tokenStorage'
import type { AuthUser, LoginCredentials, LoginResponse } from '../types/auth'

export const authRepository = {
  async login(credentials: LoginCredentials): Promise<{ user: AuthUser; access: string; refresh: string }> {
    // Get tokens
    const { data: tokens } = await axiosClient.post<LoginResponse>('/auth/login/', credentials)
    tokenStorage.setTokens(tokens.access, tokens.refresh)

    // Fetch current user
    const { data: user } = await axiosClient.get<AuthUser>('/auth/me/')
    return { user, access: tokens.access, refresh: tokens.refresh }
  },

  async logout(): Promise<void> {
    try {
      await axiosClient.post('/auth/logout/')
    } catch {
      // Ignore errors — we clear tokens regardless
    }
    tokenStorage.clearTokens()
  },

  async me(): Promise<AuthUser> {
    const { data } = await axiosClient.get<AuthUser>('/auth/me/')
    return data
  },

  async refresh(): Promise<string> {
    const refresh = tokenStorage.getRefreshToken()
    if (!refresh) throw new Error('No refresh token')
    const { data } = await axiosClient.post<{ access: string }>('/auth/refresh/', { refresh })
    tokenStorage.setAccessToken(data.access)
    return data.access
  },

  isAuthenticated(): boolean {
    return tokenStorage.hasTokens()
  },
}
